
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(()=> ({
    containerInput: {
       
            '& .MuiFormControl-root': {
                '& label':{
                    color: "#06132f",
                },
             
                '& input:focus': {
                    '&, &::after' :{
                        borderBottom:"2px solid #06132f !important", 
                        zIndex: "2"
                    },
                }
         }

    },
    containerActividadFiscal: { 
        marginTop: "12px",
            '& label':{
                position:"sticky",
                color: "#06132f",
                fontSize: "12px",
                marginBottom: "16px",
                marginLeft:"4px"
            },
            '& input': { 
               textAlign:"start",
                height: "160px",
                wordBreak: "break-word",
            },
            '& textarea': {
                marginTop: "4px",
                height: "85%",
                width: "100%",
                borderRadius: "10px",
                resize:"none"
            },
            
        
     
    }
}))